import React from 'react';
import groupBy from 'lodash/groupBy';
import { useGetList, useTranslate } from 'ra-core';
import { Creative } from './types';
import OfferCreativeListItem from './OfferCreativeListItem';
import Section from '../../../../components/ui/Section';

type Props = {
  offerId: string;
  onCreativeOpen: (creativeId: string) => void;
};

function OfferCreativeList({ offerId, onCreativeOpen }: Props) {
  const t = useTranslate();
  const { data: offerCreatives = [] } = useGetList<Creative>(
    `offers/${offerId}/creatives`
  );

  if (!offerCreatives.length) return null;

  const creativesByLang = groupBy(offerCreatives, 'lang');

  return (
    <div>
      <p className="text-xs font-semibold text-muted-foreground uppercase tracking-wide mb-2">
        {t('common.text.creatives')}
      </p>
      <div className="grid gap-4">
        {Object.entries(creativesByLang).map(([lang, creatives]) => (
          <Section title="" key={lang}>
            <p className="text-xs font-semibold text-muted-foreground uppercase tracking-wide">
              {t(`constant.language.${lang}`)}
            </p>
            {creatives?.map(creative => (
              <OfferCreativeListItem
                key={creative.id}
                offerCreative={creative}
                onOpen={() => onCreativeOpen(creative.id)}
              />
            ))}
          </Section>
        ))}
      </div>
    </div>
  );
}

export default OfferCreativeList;
